import styled from 'styled-components'
import getBreakpoint from '@client/utils/breakpoints'

import SMBImage from '@components/Image'
import { H2, H4, H6 } from '@components/Text'

import { Button as YogaButton } from '@gympass/yoga'
import Container from '@components/Container'

export const BrokerWrapper = styled.section`
  background-color: var(--white);
`
export const Main = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-top: 118px;
  padding-bottom: 32px;
  text-align: center;
  margin: auto;
  width: 350px:

  @media (min-width: ${getBreakpoint('xl')}px) {
    height: calc(100vh - 281px);
    width: 510px;
  }

  @media (min-width: ${getBreakpoint('md')}px) {
    height: calc(100vh - 281px);
    width: 510px;
    text-align: center;
  }

  @media (max-width: ${getBreakpoint('sm')}px) {
    height: calc(100vh - 120px);
    text-align: center;
    margin-bottom: 40px;
    width: 510px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  @media (max-width: ${getBreakpoint('xs')}px) {
    height: calc(100vh - 60px);
    margin-bottom: 80px;
    text-align: center;
    font-size: 18px;
    width: 250px;
  }
`

export const Title = styled(H2)`
  font-weight: 900;
  line-height: 42px;
  color: #231b22;
  font-family: Rubik;
`

export const Subtitle = styled(H4)`
  font-weight: 400;
  line-height: 28px;
  margin-top: 16px;
  font-family: Rubik;
`

export const ButtonWrapper = styled.section`
  margin-top: 32px;
`

export const Image = styled(SMBImage)`
  width: 316px;
  height: 316px;
  @media (min-width: ${getBreakpoint('xl')}px) {
    margin-top: -32px;
    margin-left: 180px;
  }

  @media (min-width: ${getBreakpoint('md')}px) {
    margin-top: -32px;
    margin-left: 92px;
  }
`

export const ButtonText = styled(H6)`
  font-weight: 700;
  font-family: Rubik;
`
export const Button = styled(YogaButton)`
  background: #231b22;
  border: 2px solid #231b22;

  &:hover {
    border-shadow: 0 4px 8px rgb(0, 0, 0, 0.45);
  }

  &:focus {
    opacity: 0.75;
    border-shadow: 0 4px 8px rgb(0, 0, 0, 0.45);
  }

  &:active {
    opacity: 0.75;
    background: #231b22;
  }
  @media (max-width: ${getBreakpoint('sm')}px) {
    width: 100%;
  }
`

export const Link = styled.a`
  color: var(--sao-paulo-60);
  font-weight: 600;
  font-family: Rubik;
`
export const BrokerContainer = styled(Container)`
  margin-top: 112px;
  height: 1065px;
`
